import React from "react";
import { NumericFormat } from "react-number-format";

const MessageUser = ({ messageType, param1, param2, param3, param4 }) => {
  return (
    <>
      {messageType === "CAG" &&
        `El agente aduanal ${param3} ha puesto un comentario en la referencia ${param2}`}

      {messageType === "CAA" &&
        `El miembro de la AAAVER ${param3} ha puesto un comentario en la referencia ${param2}`}

    {messageType === "DAN" &&
    `Sin mensaje`}

      {messageType === "CMA" && (
        <>
          <p style={{padding: '0px', margin: '0px'}}>
            El agente aduanal {param4} subió su deuda a &nbsp;
            <NumericFormat
              prefix={"$"}
              suffix={" USD"}
              decimalSeparator={"."}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              displayType="text"
              value={param1}
            />{" "}
            &nbsp; lo que hace su deuda <b>muy alta</b>
          </p>
        </>
      )}

      {messageType === "CAL" && (
        <>
          <p style={{padding: '0px', margin: '0px'}}>
            El agente aduanal {param4} subió su deuda a &nbsp;
            <NumericFormat
              prefix={"$"}
              suffix={" USD"}
              decimalSeparator={"."}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              displayType="text"
              value={param1}
            />{" "}
            &nbsp; lo que hace su <b>deuda alta</b>
          </p>
        </>
      )}

      {messageType === "CMD" && (
        <>
          <p style={{padding: '0px', margin: '0px'}}>
            El agente aduanal {param4} subió su deuda a &nbsp;
            <NumericFormat
              prefix={"$"}
              suffix={" USD"}
              decimalSeparator={"."}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              displayType="text"
              value={param1}
            />{" "}
            &nbsp; lo que hace su <b>deuda media</b>
          </p>
        </>
      )}
    </>
  );
};

export default MessageUser;
